"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = formatNumber;
exports.formatDisplayNumber = formatDisplayNumber;
exports.parseFormattedNumber = parseFormattedNumber;
exports.formatSalaryRange = formatSalaryRange;
exports.formatDate = formatDate;
exports.formatDateTime = formatDateTime;
exports.formatRelativeTime = formatRelativeTime;
exports.formatStatusLabel = formatStatusLabel;
exports.generateSlug = generateSlug;
exports.truncateText = truncateText;
const enums_js_1 = require("../constants/enums.js");
/**
 * Format a number with thousand separators (dot for id-ID locale).
 * Returns empty string for null/undefined/NaN/0 (useful for inputs).
 */
function formatNumber(value) {
    if (value == null || isNaN(value) || value === 0)
        return '';
    return new Intl.NumberFormat('id-ID').format(value);
}
/**
 * Format a number for display with thousand separators.
 * Always returns a string, including "0" for zero values.
 */
function formatDisplayNumber(value) {
    if (value == null || isNaN(value))
        return '0';
    return new Intl.NumberFormat('id-ID').format(value);
}
/**
 * Parse a formatted number string back to a numeric value.
 * Removes thousand separators (dots) and handles empty/invalid input.
 */
function parseFormattedNumber(value) {
    if (!value)
        return 0;
    // Remove thousand separators (dots for id-ID locale)
    const cleaned = value.replace(/\./g, '').replace(/,/g, '.');
    const num = Number(cleaned);
    return isNaN(num) ? 0 : num;
}
function formatSalaryRange(range) {
    if (!range)
        return 'Not specified';
    const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: range.currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });
    return `${formatter.format(range.min)} - ${formatter.format(range.max)}`;
}
function formatDate(date, locale = 'id-ID') {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });
}
function formatDateTime(date, locale = 'id-ID') {
    const d = typeof date === 'string' ? new Date(date) : date;
    return d.toLocaleString(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
}
function formatRelativeTime(date) {
    const d = typeof date === 'string' ? new Date(date) : date;
    const now = new Date();
    const diffMs = now.getTime() - d.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMins < 1)
        return 'Just now';
    if (diffMins < 60)
        return `${diffMins} minutes ago`;
    if (diffHours < 24)
        return `${diffHours} hours ago`;
    if (diffDays < 7)
        return `${diffDays} days ago`;
    return formatDate(d);
}
function formatStatusLabel(status) {
    const labels = {
        [enums_js_1.HIRING_REQUEST_STATUS.DRAFT]: 'Draft',
        [enums_js_1.HIRING_REQUEST_STATUS.GATHERING_CRITERIA]: 'Gathering Criteria',
        [enums_js_1.HIRING_REQUEST_STATUS.CRITERIA_COMPLETE]: 'Criteria Complete',
        [enums_js_1.HIRING_REQUEST_STATUS.JD_GENERATED]: 'JD Generated',
        [enums_js_1.HIRING_REQUEST_STATUS.PENDING_FEEDBACK]: 'Pending Feedback',
        [enums_js_1.HIRING_REQUEST_STATUS.HIRING]: 'Hiring',
        [enums_js_1.HIRING_REQUEST_STATUS.COMPLETED]: 'Completed',
        [enums_js_1.HIRING_REQUEST_STATUS.CANCELLED]: 'Cancelled'
    };
    return labels[status] || status;
}
function generateSlug(text) {
    return text
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .trim();
}
function truncateText(text, maxLength) {
    if (text.length <= maxLength)
        return text;
    return text.substring(0, maxLength - 3) + '...';
}
//# sourceMappingURL=formatting.js.map